import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Employee } from 'src/app/models/firebase/employee';
import { DbService } from '../db/db.service';
import { EmployeeStatusEnum } from 'src/app/enums/employeeState.enum';

@Injectable({
    providedIn: 'root'
})
export class EmployeesService {
    constructor(
        private dbService: DbService,

    ) { }

    async getEmployees(projectId: string) {
        console.log('getEmployees', projectId);

        const res = await this.dbService.getCollectionData(projectId, Employee.PATH)
            .where('is_deleted', '==', false)
            .where('page.show', '==', true)
            .where('state', '==', EmployeeStatusEnum.Active)
            .get();

        if (!res || res.empty) {
            return [];
        }
        const employees: Employee[] = res.docs.map((doc) => {
            const employee = new Employee(doc.data());
            return employee;
        });

        employees.sort((a, b) => a.orderIndex - b.orderIndex);
        return employees;
    }
}
